// import { useState } from "react";
// import { IconButton, Popover, Typography, Box } from "@mui/material";
// // import FunctionsIcon from '@mui/icons-material/Functions';
// import CalculateIcon from "@mui/icons-material/Calculate";
// import { Info } from "@mui/icons-material";

// const WeightInfo = ({ data }) => {
//   const [anchorEl, setAnchorEl] = useState(null);

//   const handleOpen = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//       const unit = data.po_unit;
//       const attachUnit = (w) => `${w} ${unit}`;
//   const open = Boolean(anchorEl);
//   const id = open ? "formula-popover" : undefined;
//   const list = [
//     // { label: "PO Number", value: data.purchase_order_number || "-" },
//   ];
//   return (
//     <>
//       <Box>
//         <Typography style={{ fontSize: "0.775rem" }}>
//           {`${data["bags as per miller"]} bags`}
//         </Typography>
//       </Box>
//       <IconButton
//         size="small"
//         onClick={handleOpen}
//         sx={{ padding: "0 0 0 4px" }}
//       >
//         <Info fontSize="inherit" />
//       </IconButton>
//       <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "left",
//         }}
//       >
//         <Box sx={{ p: 2, display: "flex", flexDirection: "column" }}>
//              "FINAL WEIGHT": attachUnit(Number(data.final_weight ?? 0).toFixed(3)), 
//              "Load Weight": attachUnit(Number(data.load_weight ?? 0).toFixed(3)),
//              "PORT NET WEIGHT": attachUnit(
//           Number(data.port_net_weight ?? 0).toFixed(3)
//         ),
        
//           {list.map((item, index) => (
//             <Typography
//               key={index}
//               style={{
//                 fontSize: "0.775rem",
//                 display: "flex",
//                 flexDirection: "row",
//               }}
//             >
//               <div
//                 style={{
//                   color: "#6b7280",
//                   maxWidth: "150px",
//                   whiteSpace: "normal",
//                 }}
//               >
//                 {item.label}:
//               </div>{" "}
//               {item.value}
//             </Typography>
//           ))}
//         </Box>
//       </Popover>
//     </>
//   );
// };

// export default WeightInfo;
import { useState } from "react";
import {
  IconButton,
  Popover,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { Info } from "@mui/icons-material";

const WeightInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;

  const unit = data.po_unit || "";
  const attachUnit = (w) => `${w} ${unit}`;

  const weights = [
    { label: "Load Weight", value: attachUnit(Number(data.load_weight ?? 0).toFixed(3)) },
    { label: "Port Net Weight", value: attachUnit(Number(data.port_net_weight ?? 0).toFixed(3)) },
    { label: "Final Weight", value: attachUnit(Number(data.final_weight ?? 0).toFixed(3)) },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography
         onClick={handleOpen}
          fontSize="0.775rem"
          sx={{
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            cursor: "pointer",
          }}>
          {attachUnit(Number(data.final_weight ?? 0).toFixed(3))}
        </Typography>
        
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, display: "flex", flexDirection: "column", minWidth: "220px" }}>
          <Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
                              Weight Details
                            </Typography>
          {weights.map((item, index) => (
            <Box key={index} mb={index < weights.length - 1 ? 1 : 0}>
              <Typography
                fontSize="0.775rem"
                display="flex"
                justifyContent="space-between"
              >
                <span style={{ color: "#6b7280" }}>{item.label}:</span>
                <span>{item.value}</span>
              </Typography>
              {index < weights.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default WeightInfo;
